export default {"src":"/_next/static/media/ConsentAsk.91fe7cb8.svg","height":218,"width":205,"blurWidth":0,"blurHeight":0};